import { Capacitor } from '@capacitor/core'
import { Browser } from '@capacitor/browser'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils.ts'
import useGlobalStore from '@/useGlobalStore.ts'

const PrivacyEulaLinks = ({ className = '' }: { className: string }) => {
	const { appVersion } = useGlobalStore()
	const { t } = useTranslation()

	return (
		<div className={cn(`flex flex-col gap-1 text-xs items-center text-gray-400`, className)}>
			<button onClick={async () => await Browser.open({ url: 'https://lingoflow.app/privacy/' })}>
				{t('Privacy policy')}
			</button>
			{Capacitor.getPlatform() === 'ios' && (
				<button
					onClick={async () =>
						await Browser.open({
							url: 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/',
						})
					}>
					{t('EULA')}
				</button>
			)}
			<span className="mt-1">{appVersion}</span>
		</div>
	)
}

export default PrivacyEulaLinks
